import { render, staticRenderFns } from "./features-library.vue?vue&type=template&id=187e9eb1&scoped=true&"
import script from "./features-library.vue?vue&type=script&lang=js&"
export * from "./features-library.vue?vue&type=script&lang=js&"
import style0 from "./features-library.vue?vue&type=style&index=0&id=187e9eb1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "187e9eb1",
  null
  
)

component.options.__file = "features-library.vue"
export default component.exports